import { fetchHandler, HTTP_METHOD, API_VERSION_ESYMANDANT, limiter } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const getMessageDetails = (accountId, akteIdHash, offset = 0, size = 50, order = 'Descending') => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/akten/timeline/${akteIdHash}?Column=CreationDate&Direction=${order}&Offset=${offset}&Size=${size}`, HTTP_METHOD.GET)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}